
import { timeRangeOptions, ProductEnum } from "@/utils/options";
import {WarehouseEum} from "modules/warehouse/enum";

const dateTypeOptions = [
    {id: 'createDate', text: '创建时间'},
    {id: 'expectDeliveryDate', text: '预计交货时间'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '仓库',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            multiple: true,
            placeholder: '仓库'
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '产品状态',
    prop: 'productState',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'productState',
        propsData: {
            options: ProductEnum.statusOption,
            placeholder: '产品状态',
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
},{
    label: '类型',
    prop: 'type',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'type',
        propsData: {
            placeholder: '类型',
            options: WarehouseEum.typeOption
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
}, {
    label: '产品类型',
    prop: 'productType',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'productType',
        propsData: {
            placeholder: '产品类型',
            options: ProductEnum.typeOption
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
}, {
    label: '品类',
    prop: 'categoryIds',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-category-select',
        prop: 'categoryIds',
        propsData: {
            placeholder: '品类',
            multiple: true
        }
    }],
    defaultValue: []
}]
